import { render, staticRenderFns } from "./AdminResellersBlocks.vue?vue&type=template&id=7742bbd4&"
import script from "./AdminResellersBlocks.vue?vue&type=script&lang=js&"
export * from "./AdminResellersBlocks.vue?vue&type=script&lang=js&"
import style0 from "./AdminResellersBlocks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports